module.exports = __webpack_public_path__ + "img/shopping_banner01.ce1640c9.png";